// Module
var code = "<h2 class=\"interiorSectionHeading\"> How It Works… </h2> <p>Cancels your obligation to repay the balance of your student loans.</p> <p><a class=\"more-link\" href=\"/manage/loan-forgiveness-discharge/total-and-permanent-disability\">Learn more about Total and Permanent Disability</a></p> ";
// Exports
export default code;